import {
  GeoJSONFeature,
} from 'maplibre-gl';

import * as CommonSelectors from './utils/common_selectors';
import { activeStates, geojsonTypes, meta, modes, cursors } from './utils/constants';
import doubleClickZoom from './utils/double_click_zoom';
import DrawPolygon from './utils/draw_polygon';
import {
  calculateSnapTolerance,
  clearSnapMarkerOnMap,
  sanitizeSnapOptions,
  setSnapMarkerOnMap,
  type SnapHitKind,
} from './utils/CalculateSnapTolerance';
import { positionToLngLat } from '../../Controls/featureCreateGeometry';
import createVertex from './utils/create_vertex';
// import {deegrees2meters, meters2degrees} from "../../utils";
import { drawModes, drawState, Source } from '../../Types';

const SnapPolygonMode:drawModes = <drawModes>{ ...DrawPolygon };

SnapPolygonMode.onSetup = function (options:any) {
  // this.map._snapPolygonMode = SnapPolygonMode;
  // try { 
  //   document.getElementsByClassName('geobox-gl-rotate-icon')[0].checked = false;
  //   document.getElementsByClassName('geobox-gl-hole-icon')[0].checked = false;
  //   document.getElementsByClassName('geobox-gl-split-icon')[0].checked = false;
  // } catch (error) {
  // }
  const polygon = this.newFeature({
    type: geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      type: geojsonTypes.POLYGON,
      coordinates: [[]],
    },
  });

  this.addFeature(polygon);

  const selectedFeatures = this.getSelected();
  this.clearSelectedFeatures();
  doubleClickZoom.disable(this);

  const state:drawState =  <drawState>{
    map: this.map,
    polygon,
    currentVertexPosition: 0,
    selectedFeatures
  };

  state.options = sanitizeSnapOptions(this._ctx.options);

  const optionsChangedCallBAck = (options:drawState["options"]) => {
    state.options = sanitizeSnapOptions(options);
  };

  state.optionsChangedCallBAck = optionsChangedCallBAck;

  this.map.on('draw.snap.options_changed', optionsChangedCallBAck);

  this.snapMarkerSource = (<Source>this.map.getSource('geobox-gl-snap-marker'))._data;
  const center = this.map.getCenter();
  state.snappedLng = center.lng;
  state.snappedLat = center.lat;
  SnapPolygonMode.state = state;
  return state;
};

SnapPolygonMode.onTap = function (state:drawState, e:any) {
  if (CommonSelectors.isVertex(e)) return this.clickOnVertex(state, e);
  this.onMouseMove(state, e);
  this.onClick(state, e);
}

SnapPolygonMode.onClick = function (state: drawState, e?: any) {
  // Recompute snap at the click location, then commit the locked vertex (not raw mouse).
  if (e) {
    SnapPolygonMode.onMouseMove.call(this, state, e);
  }
  const lng = state.snappedLng;
  const lat = state.snappedLat;

  if (state.currentVertexPosition > 0) {
    
    const lastVertex:number[] = state.polygon.coordinates[0][state.currentVertexPosition - 1];

    state.lastVertex = lastVertex;

    if (lastVertex[0] === lng && lastVertex[1] === lat) {
      SnapPolygonMode.state = <drawState>{};
      return this.changeMode(modes.SIMPLE_SELECT, {
        featureIds: [state.polygon.id],
      });
    }
  }

  state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, lng, lat);

  state.currentVertexPosition++;

  state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, lng, lat);
};

SnapPolygonMode.onMouseMove = function (state:drawState, e:any) {
  const { lng, lat } = e.lngLat;
  let minDistance = Infinity;
  let desiredCoord: number[] | undefined;
  let snapKind: SnapHitKind | undefined;

  if (state.options.snap) {
    [minDistance, desiredCoord, snapKind] = calculateSnapTolerance(this.map, e, state);
  }

  const locked = Boolean(
    state.options.snap &&
      desiredCoord &&
      Number.isFinite(minDistance) &&
      minDistance <= (state.options.snapTolerance ?? Infinity)
  );

  if (locked && desiredCoord) {
    const [snapLng, snapLat] = positionToLngLat(desiredCoord as [number, number]);
    state.snappedLng = snapLng;
    state.snappedLat = snapLat;
  } else {
    state.snappedLng = lng;
    state.snappedLat = lat;
  }

  // Keep snap hit for marker update below.
  (state as any)._snapLocked = locked;
  (state as any)._snapKind = locked ? snapKind : null;

  // if (state.options.limitDrawLength && state.options.limitDrawBearing){

  //   if (state.polygon.coordinates[0].length >= 2){
  //     var limitDrawLength = document.getElementById('geobox-gl-geometry-length-parameter');
  //     var limitDrawBearing = document.getElementById('geobox-gl-geometry-bearing-parameter');

  //     if (limitDrawLength){
  //       const pXY0 = state.polygon.getCoordinate(`0.${state.currentVertexPosition-1}`);
  //       const pXY0_3857 = deegrees2meters(pXY0);
  //       const pXY2_3857 = [];
  //       if (Number(limitDrawBearing.value) === 90){
  //         pXY2_3857[0] = pXY0_3857[0];
  //         pXY2_3857[1] = pXY0_3857[1]+ Number(limitDrawLength.value);
  //       }else if (Number(limitDrawBearing.value) === 270){
  //         pXY2_3857[0] = pXY0_3857[0];
  //         pXY2_3857[1] = pXY0_3857[1]- Number(limitDrawLength.value);
  //       }else {
  //         pXY2_3857[0] = pXY0_3857[0]+ Number(limitDrawLength.value)*Math.cos(Number(limitDrawBearing.value)*Math.PI/180);
  //         pXY2_3857[1] = pXY0_3857[1]+ Number(limitDrawLength.value)*Math.sin(Number(limitDrawBearing.value)*Math.PI/180);
  //       }

  //       const pXY2 = meters2degrees(pXY2_3857);
        
  //       state.snappedLng = pXY2[0];
  //       state.snappedLat = pXY2[1];
  //     }
  //   }
  // }else {
    // if (state.options.limitDrawLength) {
    //   if (state.polygon.coordinates[0].length >= 2){
    //     var limitDrawLength = document.getElementById('geobox-gl-geometry-length-parameter');
    //     if (limitDrawLength){
    //       const pXY0 = state.polygon.getCoordinate(`0.${state.currentVertexPosition-1}`);
    //       const pXY0_3857 = deegrees2meters(pXY0);
    //       const pXY1_3857 = deegrees2meters([lng, lat]);
    //       const pXY2_3857 = [];
         
    //       var dy = pXY1_3857[1]-pXY0_3857[1];
    //       var dx = pXY1_3857[0]-pXY0_3857[0];
  
    //       if (dx >= 0 ){
    //         pXY2_3857[0] = pXY0_3857[0]+ Number(limitDrawLength.value)*Math.cos(Math.atan(dy/dx));
    //         pXY2_3857[1] = pXY0_3857[1]+ Number(limitDrawLength.value)*Math.sin(Math.atan(dy/dx));
    //       }else {
    //         pXY2_3857[0] = pXY0_3857[0]- Number(limitDrawLength.value)*Math.cos(Math.atan(dy/dx));
    //         pXY2_3857[1] = pXY0_3857[1]- Number(limitDrawLength.value)*Math.sin(Math.atan(dy/dx));
    //       }
  
    //       const pXY2 = meters2degrees(pXY2_3857);
        
    //       state.snappedLng = pXY2[0];
    //       state.snappedLat = pXY2[1];
    //     }
    //   }
    // }
  
    // if (state.options.limitDrawBearing) {
    //   if (state.polygon.coordinates[0].length >= 2){
    //     var limitDrawBearing = document.getElementById('geobox-gl-geometry-bearing-parameter');
    //     if (limitDrawBearing){
    //       const pXY0 = state.polygon.getCoordinate(`0.${state.currentVertexPosition-1}`);
    //       const pXY0_3857 = deegrees2meters(pXY0);
    //       const pXY1_3857 = deegrees2meters([lng, lat]);
    //       const pXY2_3857 = [];

    //       if (Number(limitDrawBearing.value) !== 90 && Number(limitDrawBearing.value) !== 270){
    //         pXY2_3857[0] = pXY1_3857[0];
    //         pXY2_3857[1] = pXY0_3857[1]+ Math.tan(Number(limitDrawBearing.value)*Math.PI/180)*(pXY2_3857[0]-pXY0_3857[0]);
    //       }else {
    //         pXY2_3857[0] = pXY0_3857[0];
    //         pXY2_3857[1] = pXY1_3857[1];
    //       }
         
    //       const pXY2 = meters2degrees(pXY2_3857);
        
    //       state.snappedLng = pXY2[0];
    //       state.snappedLat = pXY2[1];
    //     }
    //   }
    // }
  // }

  if (state.options.snap) {
    setSnapMarkerOnMap(this.map, state.snappedLng, state.snappedLat, {
      locked: Boolean((state as any)._snapLocked),
      kind: (state as any)._snapKind ?? null,
    });
  } else {
    clearSnapMarkerOnMap(this.map);
  }

  state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, state.snappedLng, state.snappedLat);

  if (
    state.lastVertex
    && state.lastVertex[0] === lng
    && state.lastVertex[1] === lat
  ) {
    this.updateUIClasses({ mouse: cursors.POINTER });
  } else {
    this.updateUIClasses({ mouse: cursors.ADD });
  }
};

SnapPolygonMode.toDisplayFeatures = function (
  state: drawState,
  geojson: GeoJSONFeature,
  display: any
) {
  const isActivePolygon = geojson.properties?.id === state.polygon.id;
  geojson.properties.active = isActivePolygon
    ? activeStates.ACTIVE
    : activeStates.INACTIVE;
  if (!isActivePolygon) return display(geojson);

  const geometry = geojson.geometry as {
    coordinates?: number[][][];
  };
  if (!geometry?.coordinates?.length) return;

  const ring = geometry.coordinates[0] || [];
  const coordinateCount = ring.length;

  geojson.properties.meta = meta.FEATURE;

  // After the first click: show vertex 0 and a rubber-band line to the cursor.
  if (coordinateCount >= 2 && coordinateCount < 3) {
    display(createVertex(state.polygon.id, ring[0], '0.0', false));
    display({
      type: geojsonTypes.FEATURE,
      properties: geojson.properties,
      geometry: {
        type: geojsonTypes.LINE_STRING,
        coordinates: [ring[0], ring[coordinateCount - 1]],
      },
    });
    return;
  }

  if (coordinateCount < 3) {
    return;
  }

  return DrawPolygon.toDisplayFeatures(state, geojson, display);
};

// This is 'extending' DrawPolygon.onStop
SnapPolygonMode.onStop = function (state:drawState) {
  SnapPolygonMode.state = <drawState>{};
  this.snapMarkerSource.features = [{
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": []
    }
  }];

  (<Source>this.map.getSource('geobox-gl-snap-marker')).setData(this.snapMarkerSource);

  this.map.getCanvasContainer().style.cursor = "grab";
  this.map.off('moveend', <any>state.moveendCallback);
  this.map.off('draw.snap.options_changed', <any>state.optionsChangedCallBAck);
  DrawPolygon.onStop.call(this, state);

};

export default SnapPolygonMode;
